<template>
  <div class="back">
    <div class="back-left" @click="back">
      <i class="el-icon-back back-left-icon"></i>
      <span>{{ backText }}</span>
    </div>
    <div class="back-right">
      <div v-for="(item, index) in title" :key="index">
        <span class="back-right-title">{{ item }}</span>
        <span
          class="back-right-separator"
          v-if="(item && index != title.length - 1) || subTitle"
          >{{ separator }}</span
        >
      </div>

      <span class="back-right-subTitle">{{ subTitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    backText: {
      type: String,
      default: "返回",
    },
    separator: {
      type: String,
      default: "/",
    },
    title: {
      type: Array,
      default: () => [],
    },
    subTitle: {
      type: String,
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #ededed;
  &-left {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 12px;
    font-weight: 600;
    color: $theme-color;
    &-icon {
      margin-right: 2px;
    }
  }
  &-right {
    display: flex;
    align-items: center;
    &-title {
      color: $text-9;
    }
    &-separator {
      color: $text-9;
      margin: 0px 4px;
    }
    &-subTitle {
      color: $text-color;
      font-weight: 600;
    }
  }
}
</style>
